module.exports = __webpack_public_path__ + "img/down-arrow.5426659e.svg";